<ndt-add-schedule-view
   [callState]="callState | async"
   [form]="form"
   (create)="onCreate()"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-add-schedule-view>
